const compareText = (a, b) => (a || "").localeCompare(b || "", undefined, { sensitivity: "base" });

export const compareAllocationSitesByClientAndSite = (a, b) => {
  const clientCompare = compareText(a.client_name, b.client_name);
  if (clientCompare !== 0) return clientCompare;

  const siteCompare = compareText(a.site_name, b.site_name);
  if (siteCompare !== 0) return siteCompare;

  return (a.site_id || 0) - (b.site_id || 0);
};

export const isSiteUnavailableInSetup = (site = {}) => Boolean(
  site.archived
  || (site.historical && site.contract_status && site.contract_status !== "Confirmed")
);

export const filterConfirmedAndSortSites = (sites = []) => (
  sites
    .filter((site) => site.historical || (!site.archived && site.contract_status === "Confirmed"))
    .sort(compareAllocationSitesByClientAndSite)
);
